export const LOGO_SIZE_VALUES_HEADER = {
    s: {
        width: 94,
        height: 36,
    },
    m: {
        width: 130,
        height: 50,
    },
    l: {
        width: 130,
        height: 50,
    },
};
export const LOGO_SIZE_VALUES_FOOTER = {
    s: {
        width: 146,
        height: 56,
    },
    m: {
        width: 146,
        height: 56,
    },
    l: {
        width: 146,
        height: 56,
    },
};
